import React from "react";
import { useTranslation } from "react-i18next";

const Button = ({ href, text, dataWId, target, className, rel, onClick }) => {
  const { t } = useTranslation();
  // Merge the caller's rel (e.g. "nofollow" on action links) with the security
  // rel we always add for new-tab links.
  const computedRel =
    [target === "_blank" ? "noopener noreferrer" : "", rel || ""].join(" ").trim() ||
    undefined;
  return (
    <a
      data-w-id={dataWId}
      href={href}
      target={target}
      rel={computedRel}
      className={`button w-inline-block${className ? ` ${className}` : ""}`}
      onClick={onClick}
    >
      <div className="button-icon">
        <img
          src="/assets/photos/Button-Icon.svg"
          alt={t("common.buttonIconAlt")}
          loading="lazy"
          className="b-icon"
        />
      </div>
      <div className="button-txt">{text}</div>
    </a>
  );
};

export default Button;
